<template>
  <header>
    <div class="header-main">
      <div class="logo" @click="toHome">
        <img src="https://images.zzt.com.cn/cdn_file/zst-official/zzt_logo-v2.png" alt="logo" />
      </div>
      <nav v-if="$route.meta.type === 'default'">
        <div v-for="(item, index) in navList" class="nav-item" :key="index" @click="toPage(item.path)"
          :class="{ active: JSON.stringify(item).includes(currentPath) }">
          <template v-if="item.isSelect">
            <el-popover placement="bottom" width="170" trigger="hover" popper-class="custom-my-popover"
              v-model="item.isLaunch">
              <div class="select-main">
                <div class="select-item" v-for="its in item.children" :key="its.path"
                  :class="{ 'active-item': its.path === currentPath }" @click="toPage(its.path)">
                  {{ its.label }}
                </div>
              </div>
              <div slot="reference">
                <p class="text">{{ item.label }}
                  <i :class="item.isLaunch ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                </p>
              </div>
            </el-popover>
          </template>
          <template v-else>
            <p class="text">{{ item.label }}</p>
          </template>
        </div>
      </nav>
      <div class="log-status" v-if="$route.meta.type === 'default'">
        <div class="unlog">
          <div class="try" @click="toRegister">申请体验</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data () {
    return {
      navList: [
        {
          label: 'AI应用',
          isSelect: true,
          isLaunch: false,
          children: [
            { label: '瞰见', path: '/aerialView' },
            { label: '深眸', path: '/patE' },
            { label: '点睛投研', path: '/goldSight' }
          ]
        },
        {
          label: '数据与模型',
          isSelect: true,
          isLaunch: false,
          children: [
            { label: '数据接口', path: '/bigData' },
            { label: '模型服务', path: '/intelligentModel' }
          ]
        },
        { label: '关于我们', path: '/aboutUs' }
      ]
    }
  },
  computed: {
    currentPath () {
      return this.$route.path
    }
  },
  methods: {
    toHome () {
      this.toPage('/home')
    },
    toRegister () {
      this.toPage('/register')
    },
    toPage (path) {
      this.$router.push(path)
      window.scrollTo(0, 0, 'smooth')
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  background-color: #fffc;
  backdrop-filter: blur(Translate(12px));
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  .header-main {
    height: $header-height;
    width: $container-width;
    margin: 0 auto;
    z-index: 5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      display: flex;
      align-items: center;
      cursor: pointer;

      .split-icon {
        padding: 0 28px;
        color: #dfdfdf;
      }

      img {
        width: Translate(289px);
      }
    }

    nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: inherit;
      margin-left: Translate(44px);

      .nav-item {
        margin: 0 Translate(44px) 0 0;
        height: inherit;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @include Text(16px, 400, 22px, #333, 'PingFangSC-Regular');

        &.active {
          .text {
            @include Text(16px, 500, 22px, #0058FF, 'PingFangSC-Medium');
          }

          .bg {
            width: Translate(80px);
            height: Translate(2px);
            background-color: #0058FF;
            position: absolute;
            bottom: Translate(0px);
          }
        }

        &:hover {
          .text {
            @include Text(16px, 500, 22px, #0058FF, 'PingFangSC-Medium');
          }
        }
      }
    }

    .product-center {
      width: Translate(88px);
      height: Translate(32px);
      border-radius: Translate(4px);
      background: #0058FF;
      text-align: center;
      cursor: pointer;
      margin-right: Translate(20px);
      @include Text(14px, 400, 32px, #ffffff, 'PingFangSC-Regular');

      &:hover {
        background-color: #337ee5;
      }
    }

    .unlog {
      display: flex;
      justify-content: center;
      align-items: center;

      .log-on {
        color: #0058FF;
        font-size: Translate(15px);
        text-align: center;
        cursor: pointer;
        font-weight: 400;
        margin: 0 0 0 Translate(20px);
      }

      .try {
        display: flex;
        justify-content: center;
        align-items: center;
        width: Translate(88px);
        height: Translate(32px);
        box-sizing: border-box;
        color: #0058FF;
        border: 1px solid #0058FF;
        font-size: Translate(14px);
        border-radius: Translate(4px);
        cursor: pointer;

        &:hover {
          background-color: #F8FAFC;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.custom-my-popover {
  // box-shadow: none;
  border: 0px;
  padding: 0px;
  border-radius: Translate(8px);

  .select-main {
    margin-top: Translate(10px);
    margin-bottom: Translate(10px);

    .select-item {
      text-align: center;
      height: Translate(44px);
      line-height: Translate(44px);
      cursor: pointer;
      font-size: Translate(14px);
      color: #333333;

      &:hover {
        background: #F3F9FF;
        color: #0058FF;
        font-weight: 500;
      }
    }

    .active-item {
      background: #F3F9FF;
      color: #0058FF;
      font-weight: 500;
    }
  }

  .popper__arrow {
    display: none;
  }
}
</style>
